import StepWrapper from "../../../components/Shared/StepWrapper/StepWrapper";
import NoConsent from "../../../components/Participant/RegistrationProcess/StartRegistrationProcess/Stepper/Forms/NoConsent";

function NhsNoVsConsent() {
  return (
    <StepWrapper>
      <NoConsent />
    </StepWrapper>
  );
}

export default NhsNoVsConsent;
